import { PayloadAction } from "@reduxjs/toolkit";

import { StationsState } from '../../types';

export const updateFilteredStations = (
  state: StationsState,
  action: PayloadAction<StationsState['stations']['data']>
) => {
  state.filteredStations.data = action.payload
};
